import { render, staticRenderFns } from "./LegalFormGuide.vue?vue&type=template&id=3c73b73c"
import script from "./LegalFormGuide.vue?vue&type=script&lang=js"
export * from "./LegalFormGuide.vue?vue&type=script&lang=js"
import style0 from "./LegalFormGuide.vue?vue&type=style&index=0&id=3c73b73c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports